import { languageMap } from ".."

languageMap.brightscript = {
	comments: { line: "'" },
}
